import { render, staticRenderFns } from "./bookmakers.vue?vue&type=template&id=09d21560&scoped=true&"
import script from "./bookmakers.vue?vue&type=script&lang=js&"
export * from "./bookmakers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d21560",
  null
  
)

export default component.exports